<style scoped lang="scss">
.gy-html {
  margin-top: 10px;
  font-size: 12px;
  text-align: center;
  border: none !important;
}

.gy-html /deep/ table {
  border-collapse: collapse;
  border-color: rgb(232, 232, 232);
}

.gy-html /deep/ table tbody tr:first-child {
  height: 26px;
  font-size: 12px;
  background: rgb(123, 127, 128);
}

.gy-html /deep/ table tbody tr:not(:first-child) {
  height: 26px;
  font-size: 12px;
  color: #606672;
}

.dialog /deep/ .el-dialog__body {
  overflow: auto;
}

.left {
  display: flex;
  align-items: center;

  .icon {
    display: inline-block;
    width: 5px;
    height: 16px;
    background: #419fff;
  }

  .txt {
    display: inline-block;
    font-weight: 400;
    font-size: 16px;
    color: #303133;
    margin-left: 12px;
  }
}
</style>

<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/report/page/wo_debug_guide" getKey="rows" :columns="columns">
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_data_select :multiple="true" :type="'equipment'" :ids.sync="yt.conditions.equipmentId"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('mujumingcheng')">
            <yi_cross_select multiple :component="'web_base_mould_list'" :ids.sync="yt.conditions.mouldId"> </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('chanpinmingcheng')">
            <yi_data_select :multiple="true" :type="'material2'" :ids.sync="yt.conditions.materialId"> </yi_data_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain>
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <template #caozuo="scope">
        <el-button @click="handleParam(scope.row)" type="text" size="small">
          {{ $t('chakangongyitiaojizhiyin') }}
        </el-button>
      </template>
    </yi_curd_table>

    <el-dialog
      class="dialog"
      :title="$t(param.title)"
      :visible.sync="param.visible"
      :width="param.width"
      destroy-on-close
      :close-on-click-modal="false"
      @close="close"
    >
      <div v-loading="loading" id="export">
        <el-descriptions :column="3" :colon="false">
          <el-descriptions-item :label="$t('shebeimingcheng')">{{ equipmentName }}</el-descriptions-item>
          <el-descriptions-item :label="$t('mojubianhao/mingcheng')">{{ mouldNo }}/{{ mouldName }}</el-descriptions-item>
          <el-descriptions-item :label="$t('chanpingbianma/mingcheng')">{{ materialCode }}/{{ materialName }}</el-descriptions-item>
        </el-descriptions>
        <div style="display: flex;flex-wrap: nowrap;align-items: center;">
          <div class="left">
            <span class="icon" />
            <div class="txt" style="display: flex;flex-wrap: nowrap;align-items: center;">
              <div>{{ $t('zuijinlianxuwendingshengchan') }}</div>
              <div style="margin-top: -1px;margin-left: 5px;">
                <el-select size="mini" v-model="count" :disabled="loading" @change="onCountChange">
                  <el-option v-for="item in countOptions" :key="item" :label="item" :value="item"></el-option>
                </el-select>
              </div>
              <div style="margin-left: 5px;">{{ $t('mogongyituijian') }}</div>
            </div>
          </div>
        </div>
        <div class="gy-html" v-html="gy"></div>
      </div>
      <div slot="footer">
        <el-button size="mini" type="default" plain @click="param.visible = false">{{ $t('quxiao') }} </el-button>
        <el-button size="mini" type="primary" :disabled="loading || !gyHtml" @click="exportPic">{{ $t('daochutupian') }} </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/javascript">
import html2canvas from 'html2canvas';
const execMathExpress = require('exec-mathexpress');

export default {
  name: 'web_process_management_tuning_guide_list',

  data() {
    return {
      currentRow: {},
      count: 20,
      countOptions: [20, 50, 100, 200, 300],
      eqId: '',
      loading: false,
      param: {
        title: 'chakangongyitiaojizhiyin',
        visible: false,
        width: '88%'
      },
      gyHtml: '',
      singleMonitorData: {},
      equipmentName: '',
      mouldNo: '',
      mouldName: '',
      materialName: '',
      materialCode: '',
      columns: [
        {
          label: 'shengchangongdanhao',
          prop: 'no',
          width: 130
        },
        {
          label: 'shebeimingcheng',
          prop: 'equipmentName',
          width: 130
        },
        {
          label: 'mujubianhao',
          prop: 'mouldNo',
          width: 130
        },
        {
          label: 'mujumingcheng',
          prop: 'mouldName',
          width: 130
        },
        {
          label: 'chanpinbianma',
          prop: 'materialCode',
          width: 130
        },
        {
          label: 'chanpinmingcheng',
          prop: 'materialName',
          width: 130
        },
        {
          label: 'zhuangtai',
          prop: 'status',
          type: 'tag',
          tags: {
            2: {
              color: '#419FFF',
              text: this.$t('fafang')
            },
            3: {
              color: '#67C23A',
              text: this.$t('shengchanzhong')
            },
            4: {
              color: '#F56C6C',
              text: this.$t('zanting')
            }
          }
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 200,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      if (!this.yt) {
        return;
      }
      this.yt.conditions = {
        orderBy: 'sort asc'
      };
      this.yt.get(1);
    }, 300);
  },
  computed: {
    eqPoints() {
      return (this.store.state.eqPoints && this.store.state.eqPoints[this.eqId]) || {};
    },
    gy() {
      if (!this.gyHtml) {
        return '';
      }
      try {
        let str = this.gyHtml;
        const i18nMatches = str.match(/\[[^\]]*\]/g) || [];
        i18nMatches.forEach(code => {
          const key = code.slice(1, -1);
          str = str.replace(code, this.$t(key));
        });

        const pointMatches = str.match(/\{[^}]*\}/g) || [];
        pointMatches.forEach(code => {
          const pointCode = code.slice(1, -1);
          const pointMeta = this.eqPoints[pointCode];
          if (!pointMeta) {
            str = str.replace(code, '');
            return;
          }

          if (pointMeta.dictTypeCode != null) {
            const dictGroup = this.store.state.dictJsonAll && this.store.state.dictJsonAll[pointMeta.dictTypeCode];
            const dictKey = parseInt(this.singleMonitorData[pointCode], 10);
            const dictLabel = dictGroup && dictGroup[dictKey];
            str = str.replace(code, dictLabel != null ? this.$t(dictLabel) : '');
            return;
          }

          if (!pointMeta.formula) {
            str = str.replace(code, this.formatPointValue(this.singleMonitorData[pointCode]));
            return;
          }

          let formula = pointMeta.formula;
          const formulaMatches = formula.match(/\{[^}]*\}/g) || [];
          formulaMatches.forEach(code2 => {
            const c2 = code2.slice(1, -1);
            const val = this.singleMonitorData[c2];
            formula = formula.replace(code2, val == null || val === '' ? 0 : val);
          });
          try {
            const result = execMathExpress(formula);
            const value = result.den ? result.num / result.den : result.num;
            str = str.replace(code, this.formatPointValue(value));
          } catch (e) {
            str = str.replace(code, '');
          }
        });
        return str;
      } catch (e) {
        console.error('调机指引模板渲染失败', e);
        return this.gyHtml || '';
      }
    }
  },
  methods: {
    formatPointValue(value) {
      if (value == null || value === '') {
        return '';
      }
      const num = Number(value);
      if (isNaN(num)) {
        return value;
      }
      return num.toFixed(2);
    },
    exportPic() {
      const el = document.getElementById('export');
      if (!el) {
        return;
      }
      html2canvas(el).then(canvas => {
        const dataURL = canvas.toDataURL('image/png');
        if (!dataURL) {
          return;
        }
        const a = document.createElement('a');
        a.download = this.$t('gongyicanshu');
        a.href = dataURL;
        a.click();
      });
    },
    close() {
      this.count = 20;
      this.gyHtml = '';
      this.singleMonitorData = {};
      this.loading = false;
    },
    onCountChange() {
      if (!this.currentRow || !this.currentRow.equipmentId) {
        return;
      }
      this.handleParam(this.currentRow, true);
    },
    handleParam(row, keepOpen) {
      if (!row || !row.equipmentId || !row.woId) {
        this.utils.errorMessage(this.$t('qingpeizhimuban'));
        return;
      }
      this.currentRow = row;
      this.equipmentName = row.equipmentName;
      this.mouldNo = row.mouldNo;
      this.mouldName = row.mouldName;
      this.materialName = row.materialName;
      this.materialCode = row.materialCode;
      this.eqId = row.equipmentId;
      this.gyHtml = '';
      this.singleMonitorData = {};
      this.loading = true;
      if (keepOpen) {
        this.param.visible = true;
      }

      const params = {
        equipmentId: row.equipmentId,
        woId: row.woId,
        count: this.count
      };

      return this.http
        .get('/web/wo/debug/guide/details?' + this.qs.stringify(params))
        .then(response => {
          const data = response && response.data;
          const gyBase64 = data && data.table && data.table.gy;
          if (!gyBase64) {
            this.utils.errorMessage(this.$t('qingpeizhimuban'));
            this.param.visible = false;
            return;
          }
          this.singleMonitorData = data.singleMonitorData || {};
          this.gyHtml = this.base64.decode(gyBase64);
          this.param.visible = true;
        })
        .catch(err => {
          this.utils.errorMessage(this.$t(err) || err);
          if (!keepOpen) {
            this.param.visible = false;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
